import React, {useState} from 'react'
import {Modal, Input, Row, Col, Button, notification } from 'antd'

function StorageLocationModalNew(props){
    const[nombre, setNombre] = useState("");
    const[id, setId] = useState("");
    const[labelVisible, setLabelVisible] = useState(false);
    const[storage, setStorage] = useState("");

    const msNotification = (type, title, desc) => {
        notification[type]({
            message: title,
            description:
            desc,
        });
    };

    const handleOk = () => {
        if(id !== ""){
            if(!labelVisible){
                if(nombre !== ""){
                    const newStorage = {
                        id : id,
                        name: nombre
                    }
                    setNombre("");
                    setId("");
                    props.handleOkModalNew(newStorage);
                    
                }else{
                    msNotification('warning', 'Almacén', 'El nombre del almacén no debe de ser vacio.');
                }
            }
            
        }else{
            msNotification('warning', 'Almacén', 'El ID del almacén no debe de ser vacio.');
        }
        
      };

    const handleCancel = () => {
        setNombre("");
        setId("");
        setLabelVisible(false);
        props.handleCancelModalNew();
    }

    const handleNameChange = (e) => {
        setNombre(e.target.value);
    }

    const handleIdChange = (e) => {
        setId(e.target.value);
    }

    const handleOnKeyUp = (e) => {
        let item = props.dataStorage.find(element => element.id.toUpperCase() === e.target.value.toUpperCase());
        if(item !== undefined){
            setStorage(item.name);
            setLabelVisible(true);
        }else{
            setStorage('');
            setLabelVisible(false);
        }
    }

    return(
        <React.Fragment>
            <Modal title="Nuevo Almacén" 
            visible={props.modalVisibleNew} 
            onOk={handleOk} 
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk}>
                  Guardar
                </Button>
              ]}>
                <Row>
                    <Col span={24}>
                        <Input value={id} onChange={handleIdChange} onKeyUp={handleOnKeyUp} placeholder="Id" maxLength={8} />
                        {labelVisible ? <p style={{color:"red"}}>*El ID ya esta asignado al almacén: {storage}</p>: null}
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input value={nombre} onChange={handleNameChange} placeholder="Nombre" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default StorageLocationModalNew;



// WEBPACK FOOTER //
// ./src/components/StorageLocationModalNew.jsx